/**
 * The date pattern the user's browser locale uses, as a hint string like
 * "MM/DD/YYYY" (en-US), "DD.MM.YYYY" (de-DE) or "YYYY/MM/DD" (ja-JP).
 * Native <input type="date"> renders in the browser locale, so this hint
 * always matches what the picker shows.
 */
export function localeDateFormatHint(): string {
    const parts = new Intl.DateTimeFormat(undefined, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    }).formatToParts(new Date(2000, 11, 31));

    return parts
        .map((p) => {
            switch (p.type) {
                case "month": return "MM";
                case "day": return "DD";
                case "year": return "YYYY";
                default: return p.value; // literal separators, e.g. "/" or "."
            }
        })
        .join("");
}

/** Computed once — the locale doesn't change within a session. */
export const DATE_FORMAT_HINT = localeDateFormatHint();